<template>
  <div class="_feed_item__note">
    <md-card :id="item.id" :key="item.id" class="message-viewport note">
      <md-card-content>
        <div class="email-form">
          <div class="_changeCard">
            <div class="_changeCard__header">
              <md-avatar class="_changeCard__avatar">
                <img src="/img/default-avatar.png" alt="Avatar" />
              </md-avatar>
              <div class="_changeCard__title">
                <md-icon class="_commentCard__type">watch_later</md-icon>
                <span
                  class="_changeCard__author"
                  v-if="item.user"
                >{{item.user.given_name}} {{item.user.family_name}}</span>
                <span v-html="item._activity"></span>
                <span class="_changeCard__time">
                  <md-icon>schedule</md-icon>
                  {{ timediff(item.createdAt) }}
                </span>
              </div>
            </div>
            <div class="_changeCard__body" v-if="item._case">
              <span>Case: </span>
              <span class="_changeCard__author"><a :href="getHref('cases', item._case.id)" target="_self">{{item._case.subject}}</a></span>
            </div>
            <div class="_changeCard__body" v-if="item._task">
              <span>Task: </span>
              <span class="_changeCard__author"><a :href="getHref('tasks', item._task.id)" target="_self">{{item._task.subject}}</a></span>
            </div>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>
<script>

export default {
  components: {
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
    };
  },
  watch: {},
  methods: {
    timediff(updatedDateTimeStamp) {
      let updatedDate = new Date(updatedDateTimeStamp);
      let now = new Date(),
        secondsPast = (now.getTime() - updatedDate.getTime()) / 1000;
      let displayDate = updatedDate.toLocaleString('default', { month: 'long' }) + " " + updatedDate.getDate() + ", " + updatedDate.getFullYear() + ", " + updatedDate.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });

      if (secondsPast < 60) return " Just now " + displayDate;
      if (secondsPast < 3600)
        return parseInt(secondsPast / 60) + " minutes ago " + displayDate;
      if (secondsPast <= 86400)
        return parseInt(secondsPast / 3600) + " hour ago " + displayDate;
      if (secondsPast > 86400)
        return displayDate;       
    },
    getHref(path,id) {
      return '#' + '/'+ path + '/' + id;
    }
  }
};
</script>

<style lang="scss" scoped>
.md-card-content {
  background-color:#ece6f7;
  padding: 15px 20px;
  line-height: 1.75em;
  position: relative;
  color:black;
}
</style>
